import VideoMarkup from './video-markup';

export default VideoMarkup;
